var _path, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyboard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11.5A1.5 1.5 0 018.5 10h15a1.5 1.5 0 011.5 1.5v8.91a1.5 1.5 0 01-1.5 1.5h-15a1.5 1.5 0 01-1.5-1.5V11.5zm1.5-.5a.5.5 0 00-.5.5v8.91a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V11.5a.5.5 0 00-.5-.5h-15z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18.5,
    width: 7.3,
    height: 1,
    rx: 0.5,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.25,
    cy: 13.75,
    r: 0.75,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.75,
    cy: 13.75,
    r: 0.75,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.75,
    cy: 13.75,
    r: 0.75,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.75,
    cy: 13.75,
    r: 0.75,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.75,
    cy: 13.75,
    r: 0.75,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 15.85,
    r: 0.75,
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.25,
    cy: 15.85,
    r: 0.75,
    fill: "currentColor"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.25,
    cy: 15.85,
    r: 0.75,
    fill: "currentColor"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.25,
    cy: 15.85,
    r: 0.75,
    fill: "currentColor"
  })));
}
var MemoSvgKeyboard = /*#__PURE__*/React.memo(SvgKeyboard);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDExLjVDNyAxMC42NzE2IDcuNjcxNTcgMTAgOC41IDEwSDIzLjQ5OTZDMjQuMzI4MSAxMCAyNC45OTk2IDEwLjY3MTYgMjQuOTk5NiAxMS41VjIwLjQxQzI0Ljk5OTYgMjEuMjM4NCAyNC4zMjgxIDIxLjkxIDIzLjQ5OTYgMjEuOTFIOC41QzcuNjcxNTcgMjEuOTEgNyAyMS4yMzg0IDcgMjAuNDFWMTEuNVpNOC41IDExQzguMjIzODYgMTEgOCAxMS4yMjM5IDggMTEuNVYyMC40MUM4IDIwLjY4NjEgOC4yMjM4NiAyMC45MSA4LjUgMjAuOTFIMjMuNDk5NkMyMy43NzU4IDIwLjkxIDIzLjk5OTYgMjAuNjg2MSAyMy45OTk2IDIwLjQxVjExLjVDMjMuOTk5NiAxMS4yMjM5IDIzLjc3NTggMTEgMjMuNDk5NiAxMUg4LjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHJlY3QgeD0iMTIiIHk9IjE4LjUiIHdpZHRoPSI3LjMiIGhlaWdodD0iMSIgcng9IjAuNSIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxjaXJjbGUgY3g9IjEwLjI1IiBjeT0iMTMuNzUiIHI9IjAuNzUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8Y2lyY2xlIGN4PSIxMi43NSIgY3k9IjEzLjc1IiByPSIwLjc1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPGNpcmNsZSBjeD0iMTUuNzUiIGN5PSIxMy43NSIgcj0iMC43NSIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxjaXJjbGUgY3g9IjE4Ljc1IiBjeT0iMTMuNzUiIHI9IjAuNzUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8Y2lyY2xlIGN4PSIyMS43NSIgY3k9IjEzLjc1IiByPSIwLjc1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPGNpcmNsZSBjeD0iMTEuNzUiIGN5PSIxNS44NDk2IiByPSIwLjc1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPGNpcmNsZSBjeD0iMTQuMjUiIGN5PSIxNS44NDk2IiByPSIwLjc1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPGNpcmNsZSBjeD0iMTcuMjUiIGN5PSIxNS44NDk2IiByPSIwLjc1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPGNpcmNsZSBjeD0iMjAuMjUiIGN5PSIxNS44NDk2IiByPSIwLjc1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { MemoSvgKeyboard as ReactComponent };